import styled from '@emotion/styled';
import type { PreparedStarterInfo } from '@racemap/utilities/functions/timing';
import type { Immutable } from 'immer';
import type { CSSProperties, FC } from 'react';
import type { Column } from './TableBody';

interface Props {
  // dump bug. multigrid requested key prop, but for react it is protected and set it undefined
  key?: string;
  cellKey: string;
  column: Column;
  style: CSSProperties;
  starter: Immutable<PreparedStarterInfo>;
  rowIndex: number;
}

export const TableCell: FC<Props> = ({ cellKey, column, style, rowIndex, starter }) => {
  return (
    <Cell key={cellKey} style={style} odd={rowIndex % 2 === 0}>
      {column.render(starter)}
    </Cell>
  );
};

const Cell = styled.div<{ odd: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${(props) => (props.odd ? '#f6f6ff' : 'unset')};
`;
